import resolveVariable from './resolve-variable';
import parseTemplate from './parse-template';

export const resolveSchemeVariables = ({
  context: { assignVariable },
  variableDefinitions,
  scheme,
}) =>
  Object.entries(variableDefinitions).reduce((acc, [varName, definition]) => {
    const computedValue =
      varName in scheme.variableOverrides
        ? scheme.variableOverrides[varName]
        : scheme.computedRules[definition.rule];

    Object.assign(
      acc,
      resolveVariable({
        varName,
        definition,
        computedValue,
        assignVariable,
      })
    );
    return acc;
  }, {});

const buildOutput = (config, { context, colorSchemes, variableDefinitions }) => {
  const templateOutput = parseTemplate(config.template, context);

  const schemeVariables = Object.fromEntries(
    Object.entries(colorSchemes).map(([id, scheme]) => [
      id,
      resolveSchemeVariables({ context, variableDefinitions, scheme }),
    ])
  );

  return {
    colors: templateOutput.colors,
    variables: {
      root: templateOutput.variables,
      schemes: schemeVariables,
    },
  };
};

export default buildOutput;
